// extracted by mini-css-extract-plugin
export var carrierIcon = "_x4-0";
export var carrierLogo = "_x4-1";
export var detailsSection = "_x4-2";